var todays_date_fortimer = "";

// Set the date we're counting down to
var countDownDate = new Date("Mar 15, 2020 23:30:00").getTime();
//2nd countdown date
var dt = new Date(countDownDate);
dt.setHours( dt.getHours() + 72 );
var countDownDate1 = new Date(dt).getTime();
//3rd countdown date
var dt1 = new Date(countDownDate);
dt1.setHours( dt1.getHours() + 136 );
var countDownDate2 = new Date(dt1).getTime();  
  
  

// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();
  var estTime = new Date();
  var currentDateTimeCentralTimeZone = new Date(estTime.toLocaleString('en-US', { timeZone: 'Europe/London' }));
  var store_time = currentDateTimeCentralTimeZone.getTime();
  if (countDownDate2 < store_time) {
  var countDown = countDownDate2;
   //conole.log('expried');
  }
  else if (countDownDate1 < store_time ) {
    var countDown = countDownDate2;
    $('.timer-main-text').html("Luxury Mothers Day Roses");
    //console.log('add 12 hours');
  }
  else if (countDownDate < store_time ) {
    var countDown = countDownDate1;
    $('.timer-main-text').html("Time left to <br>ensure Mother's Day Delivery");
    //console.log('add 8 hours');
  }
  else { 
    var countDown = countDownDate;
    $('.timer-main-text').html("Time left to <br>Enjoy £10 off<br> Mothers Day Roses");
    //console.log('no time added');
  }
  
  // Find the distance between now and the count down date
  var distance = countDown - store_time;
    
  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
  // Output the result in an element with id="demo"
  $("#countdowntimer-demo").html("<span>"+ "<span>"+days +"</span>"+ "Days" +"</span>"+"<span>"+ "<span>"+hours +"</span>"+ "Hours" +"</span>"+"<span>"+ "<span>"+minutes +"</span>"+ "Minutes" +"</span>"+"<span>"+ "<span>"+seconds +"</span>"+ "Seconds" +"</span>");
  $("#mobile-countdowntimer-demo").html("<span>"+ "<span>"+days +"</span>"+ "Days" +"</span>"+"<span>"+ "<span>"+hours +"</span>"+ "Hours" +"</span>"+"<span>"+ "<span>"+minutes +"</span>"+ "Minutes" +"</span>"+"<span>"+ "<span>"+seconds +"</span>"+ "Seconds" +"</span>")

  
  
//   <span><span>01</span>Days</span>
    
  // If the count down is over, write some text 
  if (distance < 0) {
    clearInterval(x);
    $("#countdowntimer-demo").html("EXPIRED");
    $("#mobile-countdowntimer-demo").html("EXPIRED");
  }
}, 1000);